<template>
    <div class="fivetown-header-container">
        <div class="black-bar"></div>
        <div class="fivetown-header-main">
            <div class="nav-right" v-on:click="toggleMenuLinks()">
                <span class="icon"><img src="/Assets/img/menu.svg" /></span>
            </div>
            <div class="logo-container">
                <a href="https://5townscentral.com" class="logo-link">
                    <img class="nav-logo" :src="settings.logoUrl">
                </a>
            </div>
            <div class="search-icon">&nbsp;</div>

            <div class="nav-mobile-close" v-on:click="toggleMenuLinks()" v-show="isActive">
                <span class="icon"><img src="/Assets/img/cancel.svg" /></span>
            </div>
            <div class="nav-links" v-bind:class="{ 'active': isActive }">

                <a href="https://deals.5townscentral.com" class="link-button" v-on:click="toggleMenuLinks(false)">DEALS</a>
                <a href="https://5townscentral.com/minyan" class="link-button" v-on:click="toggleMenuLinks(false)">MINYAN</a>
                <a href="https://5townscentral.com/category/simcha/" class="link-button" v-on:click="toggleMenuLinks(false)">SIMCHA</a>
                <a href="https://5townscentral.com/category/nichum/" class="link-button" v-on:click="toggleMenuLinks(false)">NICHUM</a>
                <a href="https://5townscentral.com/classifieds" class="link-button" v-on:click="toggleMenuLinks(false)">CLASSIFIEDS</a>
                <a href="https://5townscentral.com/market" class="link-button" v-on:click="toggleMenuLinks(false)">MARKET</a>
                <a href="https://5townscentral.com" class="link-button" v-on:click="toggleMenuLinks(false)">RESOURCES</a>
                <a href="https://5townscentral.com/contact" class="link-button" v-on:click="toggleMenuLinks(false)">CONTACT</a>
                <a href="https://5townscentral.com/login" class="link-button" v-on:click="toggleMenuLinks(false)">LOGIN/REGISTER</a>



            </div>


            <div class="link-buttons">
                <a href="https://deals.5townscentral.com" class="link-button">DEALS</a>
                <a href="https://5townscentral.com/minyan" class="link-button">MINYAN</a>
                <a href="https://5townscentral.com/category/simcha/" class="link-button">SIMCHA</a>
                <a href="https://5townscentral.com/category/nichum/" class="link-button">NICHUM</a>
                <a href="https://5townscentral.com/classifieds" class="link-button">CLASSIFIEDS</a>
                <a href="https://5townscentral.com/market" class="link-button">MARKET</a>
                <a href="https://5townscentral.com" class="link-button">RESOURCES</a>
                <a href="https://5townscentral.com/contact" class="link-button">CONTACT</a>
                <a href="https://5townscentral.com/login" class="link-button">LOGIN/REGISTER</a>
            </div>

        </div>
    </div>
</template>

<script>
    import settings from '@/settings'
    export default {
        data() {
            return {
                isActive: false
            }
        },
        computed: {
            settings: function () {
                return settings;
            }
        },
        methods: {
            toggleMenuLinks(toggleValue) {
                this.isActive = (toggleValue || !this.isActive);
            }
        }
    }
</script>